import { DialogContentType } from '../../../enums/dialog-type.enum';

export interface DialogState {
    isDialogDisplayed: boolean;
    dialogContentType?: DialogContentType;
    isManageUsersDialogDisplayed: boolean;
}

export const initialDialogState: DialogState = {
    isDialogDisplayed: false,
    isManageUsersDialogDisplayed: false
};
